.snap-product-logo {
  display: flex;

  svg {
    width: 100%;
  }
}
